import React, { useRef } from "react";
import { Box, Button, Typography, IconButton, Grid, Card, CardMedia } from "@mui/material";
import { CameraAlt, VideoCameraBack, Delete, Replay } from "@mui/icons-material";
import { motion } from "framer-motion";
import { uploadMedia } from "../../../utils/MediaUploader";

export default function MediaContainer({ formData, setFormData }) {
  const photoInputRef = useRef(null);
  const videoInputRef = useRef(null);

    const LOCAL_STORAGE_KEY = 'reportFormData';
  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    let mediaUrl = null

    mediaUrl = URL.createObjectURL(file);
    const uploaded = await uploadMedia(file);
    if (uploaded?.url) {
        mediaUrl = uploaded.url ;
    }
    // setFormData((prev) => ({
    //   ...prev,
    //   media: file,
    //   media_url: mediaUrl,
    // }));

    const updated = { ...formData, media_url: mediaUrl };
    setFormData(updated);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
  };

  const handleRemoveMedia = () => {
    // setFormData((prev) => ({
    //   ...prev,
    //   media: null,
    //   media_url: "",
    // }));

    const updated = { ...formData, media_url: null };
    setFormData(updated);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(updated));
  };

  const renderPreview = () => {
    if (!formData?.media_url) return null;


    const getCleanExtension = (url) => {
    try {
        const pathname = new URL(url).pathname;
        return pathname.split('.').pop()?.toLowerCase();
    } catch {
        return '';
    }
    };

    const isVideo = (url) => ['mp4', 'webm', 'ogg'].includes(getCleanExtension(url));
    const mediaName = formData.media?.name || "Uploaded Media";

    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4 }}
      >
        <Card
          sx={{
            mt: 2,
            position: "relative",
            width: "100%",
            maxWidth: 400,
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          }}
        >
          {isVideo(formData.media_url) ? (
            <CardMedia
              component="video"
              src={formData.media_url}
              controls
              sx={{ height: 250, objectFit: "cover" }}
            />
          ) : (
            <CardMedia
              component="img"
              src={formData.media_url}
              alt="Preview"
              sx={{ height: 250, objectFit: "cover" }}
            />
          )}

          {/* Remove / Replace Buttons */}
          <Box
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              display: "flex",
              gap: 1,
              backgroundColor: "rgba(0,0,0,0.5)",
              borderRadius: "12px",
              p: 0.5,
            }}
          >
            <IconButton color="error" onClick={handleRemoveMedia} size="small">
              <Delete sx={{ color: "white" }} />
            </IconButton>
            <IconButton
              color="info"
              onClick={() =>
                formData.media?.type?.startsWith("video")
                  ? videoInputRef.current.click()
                  : photoInputRef.current.click()
              }
              size="small"
            >
              <Replay sx={{ color: "white" }} />
            </IconButton>
          </Box>

          <Typography
            variant="body2"
            sx={{
              p: 1,
              textAlign: "center",
              backgroundColor: "#fafafa",
              fontWeight: 500,
              color: "#444",
            }}
          >
            {mediaName}
          </Typography>
        </Card>
      </motion.div>
    );
  };

  return (
    <Box mt={2}>
      <Typography fontWeight={600} mb={1}>
        Upload Media (Image or Video)
      </Typography>

      {!formData?.media_url && (
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", gap: 2 }}
        >
          {/* Take Photo Button */}
          <Button
            variant="contained"
            color="primary"
            onClick={() => photoInputRef.current.click()}
            startIcon={<CameraAlt />}
            size="small"
          >
            Photo
          </Button>
          <input
            type="file"
            accept="image/*"
            capture="environment"
            ref={photoInputRef}
            onChange={handleFileChange}
            required={!formData.media_url}
            style={{ display: "none" }}
          />

          <Typography variant="body2" sx={{ color: "#777" }}>
            OR
          </Typography>

          {/* Record Video Button */}
          <Button
            variant="contained"
            color="secondary"
            onClick={() => videoInputRef.current.click()}
            startIcon={<VideoCameraBack />}
            size="small"
          >
            Video
          </Button>
          <input
            type="file"
            accept="video/*"
            capture="environment"
            ref={videoInputRef}
            onChange={handleFileChange}
            required={!formData.media_url}
            style={{ display: "none" }}
          />
        </Grid>
      )}

      {renderPreview()}
    </Box>
  );
}
